import KeepInTouchInstagramStaticGrid from './KeepInTouchInstagramStaticGrid';

export default KeepInTouchInstagramStaticGrid;
